(function (angular) {
    angular
        .module('one.admin')
        .run(run);

    run.$inject = ['$rootScope', 'config'];

    function run($rootScope, config) {
        $rootScope.template = config.path.template;
    }
})(angular);
